import React, { useState, useRef } from 'react'
import { TMapBasicData } from '@/tmapBasicInfo/TMapBasicData'
import { TMapBasicLogic } from '@/tmapBasicInfo/TMapBasicLogic'
import { TimeTableModalView } from './TimeTableModalView'

type Props = {
  mapRank: number
  mapSeed: number
}

const ResultView = ({ mapRank, mapSeed }: Props) => {
  const basicData: TMapBasicData = TMapBasicLogic.calculateBasicData(mapRank, mapSeed)

  // #region フック

  const [isOpenTimeTable, setIsOpenTimeTable] = useState<boolean>(false)
  const floor = useRef<number>(-1)
  const boxIndex = useRef<number>(-1)

  // #endregion フック

  // #region スタイル

  const resultStyle = {
    fontFamily: 'ＭＳ ゴシック'
  }

  const tBoxStyle = {
    color: 'blue'
  }

  // #endregion スタイル

  // #region イベント

  const onTBoxClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    const tBoxId = e.currentTarget.getAttribute('data-tbox-id')
    floor.current = parseInt(tBoxId?.split('_')[0] || '-1')
    boxIndex.current = parseInt(tBoxId?.split('_')[1] || '-1')
    setIsOpenTimeTable(true)
  }

  const closeModal = () => {
    setIsOpenTimeTable(false)
  }

  // #endregion イベント

  const printFloorMap = (basicData: TMapBasicData): JSX.Element[] => {
    const list: JSX.Element[] = []
    const tBoxRankLabel = ['Ｉ', 'Ｈ', 'Ｇ', 'Ｆ', 'Ｅ', 'Ｄ', 'Ｃ', 'Ｂ', 'Ａ', 'Ｓ']
    for (let i = 0; i < basicData.floorMapDataList.length; i++) {
      list.push(
        <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-label`}>
          地下{basicData.floorMapDataList[i].floor.toString(10).padStart(2, '0')}階<br />
        </React.Fragment>
      )
      for (let j = 0; j < basicData.floorMapDataList[i].height; j++) {
        for (let k = 0; k < basicData.floorMapDataList[i].width; k++) {
          if (
            basicData.floorMapDataList[i].getFloorMapValue(k, j) == 1 ||
            basicData.floorMapDataList[i].getFloorMapValue(k, j) == 3
          ) {
            list.push(
              <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}>
                ■
              </React.Fragment>
            )
          } else if (
            basicData.floorMapDataList[i].getFloorMapValue(k, j) == 4 &&
            JSON.stringify(basicData.floorMapDataList[i].upStairsCoordinate) ===
              JSON.stringify({ x: k, y: j })
          ) {
            list.push(
              <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}>
                △
              </React.Fragment>
            )
          } else if (basicData.floorMapDataList[i].getFloorMapValue(k, j) == 5) {
            list.push(
              <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}>
                ▽
              </React.Fragment>
            )
          } else if (basicData.floorMapDataList[i].getFloorMapValue(k, j) >= 10) {
            list.push(
              <a
                href='#'
                style={tBoxStyle}
                key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}
                data-tbox-id={`${basicData.floorMapDataList[i].floor}_${
                  ((basicData.floorMapDataList[i].getFloorMapValue(k, j) / 10) | 0) - 1
                }`}
                onClick={onTBoxClick}
              >
                {tBoxRankLabel[basicData.floorMapDataList[i].getFloorMapValue(k, j) % 10]}
              </a>
            )
          } else {
            list.push(
              <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}-${k}`}>
                {'　'}
              </React.Fragment>
            )
          }
        }
        list.push(
          <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-${j}`}>
            <br />
          </React.Fragment>
        )
      }
      list.push(
        <React.Fragment key={`${basicData.mapRank}-${basicData.mapSeed}-${i}-br`}>
          <br />
        </React.Fragment>
      )
    }
    return list
  }

  return (
    <pre style={resultStyle}>
      地図Rank：0x{basicData.mapRank.toString(16).toUpperCase()}, 地図Seed：0x
      {basicData.mapSeed.toString(16).toUpperCase()}
      <br />
      {basicData.mapName1.name}
      {basicData.mapName2.name}
      {basicData.mapName3.name}
      Lv{basicData.mapLevel}の地図
      <br />
      マップタイプ：{basicData.mapType.name}
      <br />
      階層：{basicData.mapFloorCount}
      <br />
      B1F敵ランク：{basicData.b1fEnemyRank}
      <br />
      ボス：{basicData.boss.name}
      <br />
      <br />
      {printFloorMap(basicData)}
      <TimeTableModalView
        isOpen={isOpenTimeTable}
        basicData={basicData}
        floor={floor.current}
        boxIndex={boxIndex.current}
        closeModal={closeModal}
      />
    </pre>
  )
}

export { ResultView }
